module.exports = __webpack_public_path__ + "img/logo-fitap-rings.bf3bc696.svg";